import './advantagesSlider/advantagesSlider'
import './anchor.js'
import './base-slider/base-slider'
import './copyToClipboard.js'
import './header/header'
import './text-slider/text-slider'
import './timeOffer/timeOffer'
import './ui-content/ui-content'



